export default "__VITE_ASSET__04035e52__"